// extracted by mini-css-extract-plugin
export default {"druckBtn":"IWPdfButton_druckBtn__NcTMX"};